{
  "buttonGenerate": "Generar QR",
  "inputTextLabel": "Texto del QR",
  "inputTextPlaceholder": "Escribe el texto deseado...",
  "buttonReset": "Generar otro QR",
  "downloadFormat": "Descargar {format}",
  "generateSuccess": "Aquí tienes tu código QR"
}
